/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(value) {
    if (!('AccessToken' in value) || value['AccessToken'] === undefined)
        return false;
    if (!('RefreshToken' in value) || value['RefreshToken'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSON(json) {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccessToken': json['AccessToken'],
        'RefreshToken': json['RefreshToken'],
    };
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON(json) {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccessToken': value['AccessToken'],
        'RefreshToken': value['RefreshToken'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData.js.map